module.exports = __webpack_public_path__ + "static/light-thumb-1f899a431e6276e74a7c2c0ea5a44576.jpg";